import { useCallback } from "react"
import { useAxiosInstances } from "../axios-instance"
import { ProdutosEnum } from "../../presentation/assets/helpers/ProdutosEnum"

export interface IProdutoResponse {
  IdProduto: number
  Descricao: string
  Ativo: boolean
}

export const useProdutoApi = () => {
  const { axiosAuthInstance } = useAxiosInstances()

  const getProdutosByIdUsuarioApi = useCallback(async (data: {
    IdUsuario: number
  }): Promise<IProdutoResponse[]> => {
    try {

      const result = await axiosAuthInstance.get('/produto/usuario', {
        params: {
          idUsuario: data.IdUsuario,
          idProduto: ProdutosEnum.AUTH_VELES
        }
      })

      if (!result.data || !result.data.result) {
        return []
      }

      return result.data.result
    } catch (error) {
      throw error
    }
  }, [axiosAuthInstance])

  return {
    getProdutosByIdUsuarioApi
  }
}
